<template>
  <div class="flashcard-container">
    <div class="mt-2" style="text-align: left;margin-left: 30px;">
      <h6 class="p-2" style="color:grey; font-size: 0.9rem;">
        {{ $t("select-persons-for-flashcard") }}
      </h6>
    </div>
    <div style="display:flex">
      <!-- Organisationsliste direkt angezeigt -->
      <div class="mt-2" style="margin-right:100px; margin-left:40px;">
        <vs-input
          class="search-input org-width"
          icon-after="search"
          :placeholder="$t('organization-search')"
          v-model="organization_search"
          icon="search"
          icon-no-border
          label-placeholder="icon-no-border"
        />
        <div class="outer-con3">
          <div class="table-container2">
            <table>
              <thead>
                <tr>
                  <th @click="sort('name')">
                    {{ $t("organization") }}
                    <div
                      class="arrow"
                      v-if="'name' === currentSort"
                      v-bind:class="ascending ? 'arrow_up' : 'arrow_down'"
                    ></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="cursor"
                  v-for="organization in organizations"
                  :key="organization.id"
                  @click="selectOrganization(organization)"
                >
                  <td
                    :class="{ active: isActiveOrganization(organization.id) }"
                  >
                    {{ organization.name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Personen der ausgewählten Organisation -->
      <div
        v-if="selectedOrganization"
        class="table-container2"
        style="padding-left:100px; margin-top:6px; border-left:1px solid #CCCCCC;"
      >
        <vs-input
          class="search-input2"
          style="padding-bottom:2px"
          icon-after="search"
          :placeholder="$t('name-search')"
          v-model="person_search"
          icon="search"
          icon-no-border
          label-placeholder="icon-no-border"
        />
        <div class="outer-con3">
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="selectAllItems"
                    style="margin-left:5px"
                  />
                </th>
                <th @click="sortA('person_last_name')">{{ $t("Name") }}</th>
                <th @click="sortA('person_first_name')">
                  {{ $t("Vorname") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="idCard in idCardsByOrganization"
                :key="idCard.id"
                class="cursor"
              >
                <td>
                  <input
                    type="checkbox"
                    :checked="isInSelectedIdCards(idCard)"
                    v-model="idCard.selected"
                    @click="addIdCard(idCard)"
                  />
                </td>
                <td>{{ idCard.person_last_name }}</td>
                <td>{{ idCard.person_first_name }}</td>
              </tr>
              <tr v-if="idCardsByOrganization.length === 0">
                <td colspan="3">Keine Ausweise vorhanden</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="display: flex; justify-content: flex-end; margin-top: 5px;">
          <div
            v-if="
              selectedOrganization && (selectedPersons.length > 0 || selectAll)
            "
            style=" margin-top: 40px; margin-left: 50px;"
          >
            <vs-button
              @click="generatePDF()"
              class="generate-pdf-button"
              icon="download"
            >
              {{ $t("generate-pdf") }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Flashcard",
  data() {
    return {
      selectedOrganization: null,
      organization_search: "",
      person_search: "",
      ascending: false,
      currentSort: "name",
      ascendingA: false,
      currentSortA: "person_last_name",
      currentSortDir: "asc",
      currentSortDirA: "asc",
      selectAll: false,
      selectedPersons: [],
    };
  },
  computed: {
    organizations() {
      let org = this.$store.getters["organization/getOrganizations"] || [];
      if (this.organization_search) {
        org = org.filter((o) =>
          o.name.toLowerCase().includes(this.organization_search.toLowerCase())
        );
      }
      return org.sort((a, b) => {
        let modifier = this.currentSortDir === "desc" ? -1 : 1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
    idCardsByOrganization() {
      if (!this.selectedOrganization) return [];
      let idCards = this.$store.getters["idCard/getIdCards"].filter(
        (c) => c.organisation_id === this.selectedOrganization.id
      );
      if (this.person_search) {
        idCards = idCards.filter(
          (c) =>
            c.person_first_name
              .toLowerCase()
              .includes(this.person_search.toLowerCase()) ||
            c.person_last_name
              .toLowerCase()
              .includes(this.person_search.toLowerCase())
        );
      }
      return idCards.sort((a, b) => {
        let modifier = this.currentSortDirA === "desc" ? -1 : 1;
        if (a[this.currentSortA] < b[this.currentSortA]) return -1 * modifier;
        if (a[this.currentSortA] > b[this.currentSortA]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    selectOrganization(organization) {
      this.selectedPersons = [];
      this.$store.dispatch("organization/loadOrganization", organization.id);
      this.$store.dispatch("idCard/loadIdCards", {
        organisation_id: organization.id,
      });
      this.selectedOrganization = organization;
    },
    addIdCard(idCard) {
      if (this.isInSelectedIdCards(idCard)) {
        this.selectedPersons = this.selectedPersons.filter(
          (p) => p.id !== idCard.id
        );
      } else {
        this.selectedPersons.push(idCard);
      }
    },
    async generatePDF() {
      const tempData = {
        id: this.selectedOrganization.id,
        list: this.selectedPersons.map((person) => person.person_id),
        includeExtraField: this.includeExtraField,
      };
      try {
        await this.$store.dispatch("organization/loadFlashcard", tempData);
      } catch (error) {
        console.error("Fehler beim Laden der Karteikarten:", error);
      }
    },

    isInSelectedIdCards(idCard) {
      return this.selectedPersons.some((p) => p.id === idCard.id);
    },
    isActiveOrganization(organizationId) {
      return (
        this.selectedOrganization &&
        organizationId === this.selectedOrganization.id
      );
    },
    selectAllItems() {
      this.idCardsByOrganization.forEach((idCard) => {
        idCard.selected = this.selectAll;
        if (!idCard.selected) {
          this.selectedPersons = this.selectedPersons.filter(
            (p) => p.id !== idCard.id
          );
        } else {
          if (!this.isInSelectedIdCards(idCard))
            this.selectedPersons.push(idCard);
        }
      });
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        this.ascending = !this.ascending;
      }
      this.currentSort = s;
    },
    sortA(s) {
      if (s === this.currentSortA) {
        this.currentSortDirA = this.currentSortDirA === "asc" ? "desc" : "asc";
        this.ascendingA = !this.ascendingA;
      }
      this.currentSortA = s;
    },
  },
});
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.active {
  background-color: #f0f0f0;
}
</style>
